import { render, staticRenderFns } from "./ForgotPassword.pug?vue&type=template&id=6d9de67e&scoped=true&lang=pug&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.scss?vue&type=style&index=0&id=6d9de67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9de67e",
  null
  
)

export default component.exports